<template>
    <div
      v-if="decision && decision.prompt && decision.prompt.trim() !== ''"
      :style="style"
      class="prompt"
    >
      <!--
        Never use v-html with end-user generated content, because it's a vector for XSS attacks
        This is what the following line used to be:
        {{ decision.prompt }}
      -->
      <span v-html="decision.prompt"></span>
    </div>
</template>

<script>
export default {
  props: {
    height: { type: Number, default: 60 },
    targetElement: {
      required: true,
      default: null
    },
    decision: { default: null }
  },
  data() {
    return {
      hasPrinted: false,
      destroyed: false,
      targetRect: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      }
    };
  },

  computed: {
    desiredBottomOffset() {
      return this.targetRect.height + 10;
    },

    style() {
      return {
        bottom: `${this.desiredBottomOffset / this.$store.state.display.scale}px`,
        height: `${this.height}px`
      };
    }
  },

  methods: {
    positionLoop() {
      // TODO: Convert this component to use media queries and respond to
      // size change events rather than polling for changes.  This is just
      // quicker to implement for now.

      if (this.destroyed) return;
      // TODO: Adjust position based on prop

      /** @type {HTMLDivElement} */
      let el = this.targetElement;
      if (el) {
        // eslint-disable-next-line no-underscore-dangle
        if (el._isVue) {
          if (!this.hasPrinted) {
            this.hasPrinted = true;
          }
          el = el.$el;
        }
        const renderRect = el.getBoundingClientRect();

        // Check here to prevent recomputing
        if (
          this.targetRect.x !== renderRect.x
            || this.targetRect.y !== renderRect.y
            || this.targetRect.width !== renderRect.width
            || this.targetRect.height !== renderRect.height
        ) {
          this.targetRect.x = renderRect.x;
          this.targetRect.y = renderRect.y;
          this.targetRect.width = renderRect.width;
          this.targetRect.height = renderRect.height;
        }
      }
      window.requestAnimationFrame(this.positionLoop);
    }
  },

  mounted() {
    this.positionLoop();
  },

  beforeDestroy() {
    this.destroyed = true;
  }
};
</script>

<style lang="scss" scoped>
.prompt
{
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--neutralColor);
  color: white;
  text-align: center;
  left: -5px;
  right: -5px;

  border: 2px solid white;
  font-size: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/game/ui/DecisionPrompt.vue